import { render, staticRenderFns } from "./ArticleTopHeadlinesSection.vue?vue&type=template&id=6301188e&scoped=true"
import script from "./ArticleTopHeadlinesSection.vue?vue&type=script&lang=ts"
export * from "./ArticleTopHeadlinesSection.vue?vue&type=script&lang=ts"
import style0 from "./ArticleTopHeadlinesSection.vue?vue&type=style&index=0&id=6301188e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6301188e",
  null
  
)

export default component.exports